import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getPartnersCount } from '@apis/partner';
import type { PartnersSearchForm } from '@models/partner';
import { dropEmptyValues } from '../../utils/common';

export const usePartnerCount = (searchParam: PartnersSearchForm) => {
  /**
   * Count must be keyed by filters so it updates correctly when filters change.
   */
  const cleanedParams = dropEmptyValues(searchParam, [
    'name',
    'manager',
    'email',
    'address',
  ]);

  const queryOptions: UseQueryOptions<number, Error> = {
    queryKey: ['partnersCount', cleanedParams],
    queryFn: () => getPartnersCount(cleanedParams),
    enabled: true,
  };

  return useQuery(queryOptions);
};
